import WebRtc from 'src/services/webrtc';

const DEFAULT_ERROR = 'Could not start the live stream';

// Connect / fail / retry flow shared by the live stream screens.
//
// The screen provides:
//   connectStream(attempt)    opens its connection(s); set each one's
//                             onFailure to (msg) => this.failStream(attempt, msg)
//   closeStreamConnections()  closes them and drops any listeners
//   onStreamFailed(message)   optional
// and its own `isLoading` and `iceState` data. It shows <stream-error> while
// `streamError` is set.
export default {
  data: () => ({
    streamError: null,
    // Bumped on every attempt; anything from an older attempt is ignored.
    streamAttempt: 0,
    streamStopped: false,
  }),

  beforeUnmount() {
    this.stopStream();
  },

  methods: {
    async startStream() {
      const attempt = ++this.streamAttempt;
      this.streamError = null;
      this.iceState = null;
      this.isLoading = true;
      try {
        await this.connectStream(attempt);
      } catch (error) {
        this.failStream(attempt, typeof error === 'string' ? error : null);
      }
    },

    isCurrentStreamAttempt(attempt) {
      return !this.streamStopped && attempt === this.streamAttempt;
    },

    failStream(attempt, message) {
      if (!this.isCurrentStreamAttempt(attempt)) return;
      this.streamError = message || DEFAULT_ERROR;
      // Stops polling and tells the device to stop; nothing is left running.
      this.closeStreamConnections();
      this.onStreamFailed?.(this.streamError);
    },

    retryStream() {
      this.closeStreamConnections();
      this.startStream();
    },

    stopStream() {
      this.streamStopped = true;
      this.closeStreamConnections();
    },

    // The server list is cached for a few minutes (failures are not), so a
    // retry reuses it.
    async loadStreamServers(iceOptions) {
      try {
        return await WebRtc.getRTCServers(iceOptions);
      } catch (error) {
        throw "Couldn't load stream servers";
      }
    },
  },
};
